import React, { useEffect, useState, useCallback, useRef } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { Polyline } from "@react-google-maps/api";
import renderArrows from "./renderArrows"; // Adjust the path as needed
import { polylineOptions, getHitAreaOptions } from "./polylinesOptions.js";

const center = {
  lat: 46.5193587,
  lng: 12.0051628,
};

function MapModuleForMaps(props) {
  const {
    filterOption,
    polygon,
    cardItemsList,
    displayOption,
    setTripId,
    setMapId,
    showManyTracks,
    filterByYear,
    filterByRegion,
  } = props;
  const [mapKey, setMapKey] = useState(Date.now());
  const needRefresh = useRef(true);
  const [zoomLevel, setZoomLevel] = useState(5);

  const [map, setMap] = React.useState(null);
  //   const [cardItemsList, setCardImetsList] = useState([]);

  const polylinesArray = cardItemsList.map(
    (item) => item.attributes.polygon.polyline,
  );

  const API_KEY = process.env.REACT_APP_googleMapsApiKey;
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: API_KEY,
  });

  // Remove bug not loading map after filter option
  useEffect(() => {
    needRefresh.current = true;
    console.log("needRefresh set to true ...", needRefresh);
  }, [
    filterOption,
    displayOption,
    showManyTracks,
    filterByYear,
    filterByRegion,
  ]);

  useEffect(() => {
    if (!map || displayOption !== "map") return;
    window.google.maps.event.trigger(map, "resize");
    zoomToObject();
  }, [map, polygon.polyline, displayOption]);

  // Remove bug not loading map after filter option
  useEffect(() => {
    if (needRefresh.current === true) {
      setMapKey(Date.now());
      console.log("Refreshing working");
      needRefresh.current = false;
    } else console.log("Refresh forbidden");
  }, [polygon.polyline, displayOption]);

  const zoomToObject = useCallback(() => {
    if (!map || !window.google) return;
    const bounds = new window.google.maps.LatLngBounds();
    polygon.polyline.forEach((point) => bounds.extend(point));
    window.google.maps.event.trigger(map, "resize");
    map.fitBounds(bounds);
  }, [polygon.polyline, map]);

  const onLoad = useCallback((map) => {
    setMap(map);
    map.addListener("zoom_changed", () => {
      setZoomLevel(map.getZoom());
    });
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const findCardId = (index) => {
    const card = cardItemsList.find((_, idx) => idx === index);
    return card ? card.id : null;
  };

  const onPolylineClicked = (index) => {
    // console.log(findCardId(index));
    setMapId(findCardId(index));
    setTripId(findCardId(index));
  };

  const path = polygon.polyline;

  return isLoaded ? (
    <div
      style={{
        display: "flex",
        flexGrow: "1",
        backgroundColor: "blue",
        flexDirection: "row",
      }}
    >
      <GoogleMap
        // mapContainerStyle={containerStyle}
        key={mapKey}
        mapContainerClassName="map"
        center={center}
        zoom={5}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {showManyTracks && (
          <>
            {polylinesArray.map((path, index) => (
              <div key={index}>
                <Polyline
                  key={index * 1000 + 1}
                  path={path}
                  options={polylineOptions}
                  onClick={() => onPolylineClicked(index)}
                />

                <Polyline
                  key={index}
                  path={path}
                  options={getHitAreaOptions(polygon)}
                  onClick={() => onPolylineClicked(index)}
                />
              </div>
            ))}
          </>
        )}

        <Polyline
          path={polygon.polyline}
          options={{
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 3,
          }}
        />
        {renderArrows(path, zoomLevel)}
        <></>
      </GoogleMap>
    </div>
  ) : (
    <></>
  );
}

export default React.memo(MapModuleForMaps);
